import {useContext} from "react";
import {CartContext, CartItem} from "../../../contexts/CartContext";
import HeaderPage from "../components/HeaderPage";
import {FlatList, TouchableOpacity, View} from "react-native";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import FontAwesome from "../components/FontAwesome";
import Text from "../components/Text";
import {ColumnSpace, RowSpace} from "../components/_CommonComponents";
import Button from "../components/Button";
import {
    CartItemDecreasePressable,
    CartItemDeletePressable,
    CartItemIncreasePressables
} from "../../../components/functional-components/CartItemPressables";
import {threeDigitsSep} from "../../../helpers";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function Cart({navigation}: any) {
    const cart = useContext(CartContext);
    const appContext = useContext(AppConfigContext);
    const colors = Colors.instance(appContext.theme, appContext.color);
    const appFunctions = useContext(AppFunctionsContext);

    return <HeaderPage title={"سفارش من"} scrollableContent={true}>
        <FlatList data={cart.cartItems}
                  contentContainerStyle={{padding: 8}}
                  renderItem={(rItem) => {
                      return <CartItemView cartItem={rItem.item}/>
                  }}/>

        {cart.totalCartPriceHasDiscount ?

            <View style={{padding: 8}}>
                <View style={{flexDirection: "row"}}>
                    <Text size={14} weight={500}>قیمت کل بدون تخفیف: </Text>
                    <RowSpace/>
                    <Text size={14} weight={500}>{`${threeDigitsSep(cart.allItemsPriceNoDiscount)} تومان`}</Text>
                </View>
                <View style={{flexDirection: "row"}}>
                    <Text size={14} weight={500}>قیمت کل با احتساب تخفیف: </Text>
                    <RowSpace/>
                    <Text size={15} weight={600}
                          color={colors.get("primaryColor") as string}>{`${threeDigitsSep(cart.allItemsPrice)} تومان`}</Text>
                </View>
            </View> :

            <View style={{padding: 8}}>
                <View style={{flexDirection: "row", alignItems: "center"}}>
                    <Text size={14} weight={500}>مجموع قیمت سفارش: </Text>
                    <RowSpace/>
                    <Text size={16} weight={500}
                          color={colors.primary}>{`${threeDigitsSep(cart.allItemsPriceNoDiscount)} تومان`}</Text>
                </View>
            </View>
        }

        <View style={{padding: 8}}>
            <Button title={"مرحله بعد"}
                    color={colors.get("primaryColor") as string}
                    onPress={appFunctions.appNavigator.cartToNextPage}/>
        </View>
    </HeaderPage>
}

function CartItemView({cartItem}: { cartItem: CartItem }) {
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    return <View style={{
        marginBottom: 8,
    }}>
        <View style={{
            flexDirection: "row",
            width: "100%",
        }}>
            <View style={{
                padding: 4,
            }}>
                <FontAwesome type={"solid"} icon={""} size={18} color={colors.get("primaryColor") as string}/>
            </View>

            <View style={{
                padding: 4,
                flexGrow: 1
            }}>
                <View style={{
                    flexGrow: 1,
                    flexDirection: "column"
                }}>
                    <CartPriceRow price="" title={cartItem.fullName} isName={true}/>
                    {cartItem.selective ?
                        <CartPriceRow price={cartItem.selective.price}
                                      title={`آیتم انتخابی: ${cartItem.selective.title}`}
                                      isName={false}/> : <></>}
                    {cartItem.additives?.map(item => {
                        return <CartPriceRow price={item.price}
                                             title={`+ ${item.title}`}
                                             isName={false}/>
                    })}
                    <ColumnSpace h={6}/>
                    <CartPriceRow price={cartItem.count} title={"تـعداد"} isName={false}/>
                    <ColumnSpace h={6}/>
                    <ItemTotalPriceRow price={cartItem.singleItemSumPrice(false)} title={"قیمت محصول"}/>
                    <ColumnSpace h={6}/>
                    {cartItem.product.hasActiveDiscount ? <View>
                        <ItemTotalPriceRow price={cartItem.singleItemSumPrice(true)} title={"قیمت با تخفیف"}/>
                        <ColumnSpace h={6}/>
                    </View> : <></>}
                    <ItemTotalPriceRow price={cartItem.totalItemSumPrice(true)} title={"قیمت تعداد"}/>
                </View>
            </View>

            <View style={{
                width: 80,
                justifyContent: "space-around"
            }}>
                <CartItemIncreasePressables cartItem={cartItem} viewClass={CartItemActionButton}
                                            title={"افزودن"} color={colors.get("green") as string} icon=""/>
                <CartItemDecreasePressable cartItem={cartItem} viewClass={CartItemActionButton}
                                           title={"کم کردن"} color={colors.get("yellow") as string} icon=""/>
                <CartItemDeletePressable cartItem={cartItem} viewClass={CartItemActionButton}
                                         title={"حذف"} color={colors.get("red") as string} icon=""/>
            </View>

        </View>
        <View style={{width: "100%", marginTop: 8, height: 2, backgroundColor: colors.get("separator") as string}}/>
    </View>
}

function CartItemActionButton({title, icon, color, onPress}
                                  : { title: string, icon: string, color: string, onPress: () => void }) {
    return <TouchableOpacity style={{
        paddingVertical: 4,
    }} onPress={onPress}>
        <View style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <FontAwesome type={"solid"} icon={icon} size={10} color={color}/>
            <RowSpace w={5}/>
            <Text color={color}>{title}</Text>
        </View>
    </TouchableOpacity>
}

function CartPriceRow({title, price, isName}: { title: string, price: number|string, isName: boolean }) {
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    return <View style={{
        width: "100%",
        flexDirection: "row"
    }}>
        <Text size={isName ? 15 : 14} weight={isName ? 600 : 400} style={{
            flex: 3,
            textAlign: "right"
        }}>{title}</Text>
        <Text size={14} style={{
            flex: 2,
            textAlign: "center"
        }} color={colors.get("primaryColor") as string}>
            {`${price}`}
        </Text>
    </View>
}

function ItemTotalPriceRow({title, price}: { title: string, price: number }) {
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    return <View style={{
        width: "100%",
        flexDirection: "row"
    }}>
        <Text size={16} style={{
            flex: 3,
            textAlign: "right"
        }} weight={600}>{title}</Text>
        <Text size={16} style={{
            flex: 2,
            textAlign: "center"
        }} weight={600} color={colors.get("primaryColor") as string}>
            {`${threeDigitsSep(price)}`}
        </Text>
    </View>
}